<div
  ngbDropdown
  class="notification-button pt-lg-1"
  [class.open]="isOpen"
  (openChange)="toggleNotificationCenter($event)"
  #notificationDropdown="ngbDropdown"
>
  <button
    class="dropdown-toggle notification-btn btn p-0 border-none d-flex"
    id="notificationDropdown"
    attr.aria-label="{{ 'nav.notification.screenreader' | translate }}"
    tabindex="-1"
    ngbDropdownToggle
  >
    <span class="icon notification-bell text-white material-icons material-mobile-nav" aria-hidden="true">notifications</span>
    <ng-container *ngIf="unseenNotificationCount$ | async">
      <span class="notification-badge">
        <div class="count-notification">{{ unseenNotificationCount$ | async }}</div>
      </span>
    </ng-container>
  </button>

  <div
    ngbDropdownMenu
    aria-labelledby="notificationDropdown"
    class="notification-dropdown shadow dropdown-menu border border-secondary bg-primary"
  >
    <div class="notification-header d-flex">
      <div class="font-heading font-size-20 text-white">
        {{ 'navbar.notifications.title' | translate: { fgbdefault: 'NOTIFICATIONS' } }}
      </div>
      <ng-container *ifScreenSize="screenSize.Mobile">
        <i class="material-icons close-btn text-grey" (click)="notificationDropdown.close()">close</i>
      </ng-container>
    </div>
    <div class="notification-body">
      <fgbcl-notification-hub (goToNotification)="closeDropDown(notificationDropdown)"></fgbcl-notification-hub>
    </div>
  </div>
  <div class="notification-mobile-backdrop"></div>
</div>
